import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { ShareService } from './vscode/src/vs/workbench/contrib/share/browser/shareService.js';
import { IShareService } from 'vscode/vscode/vs/workbench/contrib/share/common/share.service';
import './vscode/src/vs/workbench/contrib/share/browser/share.contribution.js';

function getServiceOverride() {
    return {
        [( IShareService.toString())]: new SyncDescriptor(ShareService, [], true)
    };
}

export { getServiceOverride as default };
